var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.tileChunks),function(chunk,i){return _c('ce-tile-chunk',{key:i,attrs:{"tiles":chunk,"lastChunk":i + 1 === _vm.numberOfChunks,"tiny":_vm.tiny}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }